














































import { Component, Vue } from "vue-property-decorator"
import AuthErrorAlert from "@/components/Auth/AuthErrorAlert.vue"
import { mapState } from "vuex"

@Component({
  components: {
    AuthErrorAlert,
  },
  computed: {
    ...mapState("Auth", {
      resetPasswordDetails: "resetPasswordDetails",
    }),
  },
})
export default class AdminResetPasswordReset extends Vue {
  isLoading = false

  errors = {}

  resetPassword() {
    this.isLoading = true
    this.$store
      .dispatch("Auth/adminResetPasswordResetPassword")
      .then(() => {
        this.$emit("submitted")
        this.isLoading = false
      })
      .catch(({ response }) => {
        this.errors = response.data.error
        this.isLoading = false
      })
  }
}
